import type { IconSvgObject } from './types';

const SplitIcon: IconSvgObject = [
  ["path", { d: "M8 3H3V8M3.5 3.5L12 12V21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M16 3H21V8M20.5 3.5L15 9", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default SplitIcon;
